import React, { Component } from 'react';
import './excel-to-json.scss';
import * as XLSX from "xlsx";

class ExcelToJson extends Component {
    state = {}

    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        this.refs.fileUploader.click();
    }

    filePathset(e) {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        console.log(file);
        this.setState({ file }, () => {
            this.readFile()
        });
    }

    readFile() {
        let f = this.state.file;
        if (!f) {
            return
        }
        let name = f.name;
        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
                let json = this.convertToJson(data)
                if (this.props.onSuccess) {
                    this.props.onSuccess({ data: json, fileName: name })
                }
            } catch (e) {
                if (this.props.onFailure) {
                    this.props.onSuccess({ error: { message: "Something went wrong" }, err: e })
                }
            }
        };

        reader.readAsBinaryString(f);
    }

    convertToJson(csv) {
        let lines = csv.split("\n");

        let result = [];

        let headers = lines[0].split(",");
        let emptyLine = 0
        for (let i = 1; i < lines.length - 1; i++) {
            let obj = {};
            let currentline = lines[i].split(",");

            for (let j = 0; j < headers.length; j++) {
                if (headers[j] == "countryCode" || headers[j] == "Country Code") {
                    obj[headers[j]] = currentline[j] ? `+${currentline[j]}` : "";
                } else {
                    obj[headers[j]] = currentline[j];
                }
            }

            let cond = Object.values(obj).every(item => !item)
            if (!cond) {
                emptyLine = 0
                result.push(obj);
            } else {
                emptyLine += 1
            }
            if (emptyLine > 1) break
        }
        return result
    }



    render() {
        return (<input className="excel-to-json" accept=".xlsx,.csv,.xlx" type="file" id="file" ref="fileUploader" onClick={() => this.handleClick()} onChange={this.filePathset.bind(this)} />)
    }
}

export default ExcelToJson;